import React, { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import Backdrop from 'src/stories/Backdrop'
import Sidedrawer from 'src/stories/Sidedrawer'
import { RouteItem } from 'src/stories/Navbar'
import Sidebar from 'src/stories/Sidebar'
import ExpandableContent from 'src/stories/ExpandableContent'
import { HamburgerIcon } from 'src/stories/assets'
import useScreenSizes from 'src/stories/hooks/useScreenSizes'

const SidedrawerContainer = styled.div(({ theme }) => ({
  padding: `0 ${theme.space(12)}`,
}))

const SidedrawerNavLink = styled(NavLink)(({ theme }) => ({
  display: 'block',
  color: theme.colors.base_100,
  textDecoration: 'none',
  fontSize: '2rem',
  padding: `${theme.space(5)} 0`,
}))

const StyledHamburgerIcon = styled(HamburgerIcon)(({ theme }) => ({
  margin: `${theme.space(7)} ${theme.space(4.5)} 0 ${theme.space(4.5)}`,
  '@media (max-width: 360px)': {
    margin: `${theme.space(5)} ${theme.space(1)} 0 ${theme.space(1)}`,
  },
  cursor: 'pointer',
}))

interface MobileNavProps {
  routes: RouteItem[]
}

const MobileNav: React.FC<MobileNavProps> = ({ routes }) => {
  const { pathname } = useLocation()
  const { isExtraSmallScreen } = useScreenSizes()

  if (isExtraSmallScreen) {
    const campaignsIndex = routes.findIndex((r) => r.label === 'Campaigns')

    if (campaignsIndex !== -1) {
      routes.splice(campaignsIndex, 1)
    }
  }

  const [openDrawer, setOpenDrawer] = useState(false)

  const theme = useTheme()

  useEffect(() => {
    setOpenDrawer(false)
  }, [pathname])

  return (
    <>
      <StyledHamburgerIcon
        fill={theme.colors.primary_2}
        onClick={() => setOpenDrawer((o) => !o)}
      />
      <Backdrop show={openDrawer} onClick={() => setOpenDrawer(false)} />
      <Sidedrawer onClose={() => setOpenDrawer(false)} open={openDrawer}>
        <SidedrawerContainer>
          {routes.map((r, idx) => {
            if (r.sidebarRoutes) {
              return (
                <ExpandableContent
                  key={`${r.label}${idx}`}
                  triggerText={r.label}
                  initiallyExpanded={
                    pathname ===
                      new URL(r.to, window.location.origin).pathname ||
                    !!r.additionalRoutes?.some((ar) => {
                      return (
                        pathname ===
                        new URL(ar, window.location.origin).pathname
                      )
                    })
                  }
                >
                  <Sidebar sidedrawer routes={r.sidebarRoutes} />
                </ExpandableContent>
              )
            } else {
              return (
                <SidedrawerNavLink key={`${r.label}${idx}`} to={r.to}>
                  {r.label}
                </SidedrawerNavLink>
              )
            }
          })}
        </SidedrawerContainer>
      </Sidedrawer>
    </>
  )
}

export default MobileNav
